import { render, staticRenderFns } from "./openOrderDurationList.vue?vue&type=template&id=acc8842e&scoped=true"
import script from "./openOrderDurationList.vue?vue&type=script&lang=ts"
export * from "./openOrderDurationList.vue?vue&type=script&lang=ts"
import style0 from "./openOrderDurationList.vue?vue&type=style&index=0&id=acc8842e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc8842e",
  null
  
)

export default component.exports